import React, { useEffect, useState } from 'react'
import { dispatchHandler } from '../../../../../helper/apiHelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { getPermissionKey } from '../../../../../helper/permissions';
import { CONFIG } from '../../../../../config';
import GenericSpinnerLoader from '../../../../../loaders/GenericSpinnerLoader';
import Icons from '../../../../../assets/icons';
import GenericToggleComponent from '../../../../../genericComponents/GenericToggleComponent';
import GenericCustomButton from '../../../../../genericComponents/GenericCustomButton';
import NoDataFound from '../../../../../genericComponents/NoDataFound';
import LanguageTranslator from '../../../../../locals/LanguageTranslator';
import { Radio } from 'antd';
import GenericStatusComponent from '../../../../../genericComponents/GenericStatusComponent';

const NotificationMatrix = (props = {}) => {

    let { filterConfig } = props || {};

    // State : to store the api response for the notification matrix
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState({});
    const [errorData, setErrorData] = useState({});
    const [updatedTableData, setUpdatedTableData] = useState([]);

    const getTableComponentListData = useSelector(state => state?.generalStore?.getTableComponentListData)
    const updateNotificationMatrixSettingData = useSelector(state => state?.administrationStore?.updateNotificationMatrixSettingData)

    const dispatch = useDispatch();

    // Fucntion : to get the data for the notification matrix
    const getData = () => {
        if (filterConfig?.["module"]) {
            setErrorData({ ...errorData, "main": "" })
            setLoading({ ...loading, "main": true });
            setUpdatedTableData([]);
            setTableData([]);

            dispatchHandler(dispatch, "getTableComponentListRequest", {
                "moduleCode": filterConfig?.["module"]?.["module_code"] || "",
                "level" : props.level,
                "apiUrl": "/admin/notification/get/all/event",
                "baseUrl": CONFIG.SM_BACKEND_BASE_URL,
            }, getPermissionKey("administration", "notification", "view"))
        }
    }

    useEffect(() => {
        if (updateNotificationMatrixSettingData?.isSuccess) {
            getData?.();
        }
    }, [updateNotificationMatrixSettingData])

    useEffect(() => {
        console.log("filter config", filterConfig);
        getData();
    }, [props.filterConfig])

    useEffect(() => {
        if (getTableComponentListData?.isSuccess) {
            setLoading({ ...loading, "main": false });
            let data = getTableComponentListData?.data?.resource || [];
            if (data) {
                setTableData(data);
            }
        }
        if (getTableComponentListData?.isError) {
            setErrorData({ ...errorData, "main": getTableComponentListData?.error?.message })
            setLoading({ ...loading, "main": false });
        }
    }, [getTableComponentListData])


    // if (loading?.["main"]) {
    //     return <div className='min-h-[250px] flex items-center justify-center'><GenericSpinnerLoader /></div>
    // }

    // if (!errorData?.["main"]) {
    //     // return <div onClick={() => { getData() }}>
    //     //     <div className='gcrb-error'>
    //     //         <div className='gcrb-error-icon'>
    //     //             <Icons.ReloadIcon />
    //     //         </div>
    //     //         <div className='gcrb-error-text'>
    //     //             {errorData?.["main"] || "Failed to fetch the data!"}
    //     //         </div>
    //     //     </div>
    //     // </div>

    //     return <div className='w-full h-full flex flex-col items-center justify-center gap-2'>
    //                 <GenericCustomButton
    //                     type='retry'
    //                     onClick={() => { getData() }}
    //                 />
    //                 {/* <p className='mb-0 text-sm text-center text-fontGrey'>{error || "Something Went Wrong!"}</p> */}
    //                 <div className='gcrb-error-text'>
    //                     {errorData?.["main"] || "Failed to fetch the data!"}
    //                 </div>
    //             </div>
    // }

    const handleChange = (type, config) => {
        switch (type) {
            case "updateTableData": {
                let modifiedData = [...(JSON.parse(JSON.stringify(updatedTableData?.length > 0 ? updatedTableData : tableData)))];
                let { key, index } = config || {};
                modifiedData[index][key] = modifiedData[index][key] == "ENABLE" ? "DISABLE" : "ENABLE";
                setUpdatedTableData(modifiedData);
                break;
            }
            case "finalSubmit": {
                let payload = updatedTableData?.map((item, index) => {
                    if (JSON.stringify(item) != JSON.stringify(tableData?.[index])) {
                        return {
                            "event": item?.event || "",
                            "moduleName": filterConfig?.module?.module_name || "",
                            "moduleCode": filterConfig?.module?.module_code || "",
                            "displayName": item?.displayName || "",
                            "active": item?.active ?? false,
                            "email": item?.email || "",
                            "weChat": item?.weChat || "",
                            "whatsapp": item?.whatsapp || "",
                            "appNotification": item?.appNotification || "",
                            "webNotification": item?.webNotification || "",
                        }
                    } else return null
                })?.filter(item => item != null);
                dispatchHandler(dispatch, "updateNotificationMatrixSettingRequest", {
                    events : payload,
                    level : props.level,
                }, getPermissionKey("administration", "notification", "manage"))
            }
            default: { break; };
        }
    }

    // Function : To render the final submit buttons here
    const renderFinalSubmitButtons = () => (
        <div className='gcrb-sec'>
            <div className='gcrbs-btns'>
                {/* Render The final Submit button and Discard Button  */}
                <GenericCustomButton
                    type="default"
                    label="Discard Changes"
                    onClick={() => setUpdatedTableData([])}
                    disabled={updatedTableData?.length == 0}
                />

                <GenericCustomButton
                    type="primary"
                    label="Save Settings"
                    onClick={() => handleChange("finalSubmit")}
                    disabled={updatedTableData?.length == 0}
                />
            </div>
        </div>
    )

    const renderTableBody = () => {
        return <tbody>
            {(updatedTableData?.length > 0 ? updatedTableData : tableData)?.map((item, index) => {

                let showRow = true;

                if (props.currentSearch) {
                    showRow = item?.displayName?.toLowerCase()?.includes(props.currentSearch?.toLowerCase());
                }

                return showRow && <tr key={index} className='border-b border-borderSlateGrey'>
                    <td key={index}>
                        <div>
                            <GenericToggleComponent
                                checked={item?.["active"]}
                                checkedComponent={<LanguageTranslator tag='span'>Active</LanguageTranslator>}
                                uncheckedComponent={<LanguageTranslator tag='span' className='pl-2'>Inactive</LanguageTranslator>}
                                onChange={() => {
                                    let modifiedData = [...(JSON.parse(JSON.stringify(updatedTableData?.length > 0 ? updatedTableData : tableData)))];
                                    modifiedData[index]["active"] = !modifiedData[index]["active"];
                                    setUpdatedTableData(modifiedData);
                                }}
                                style={{
                                    width: '75px'
                                }}
                            />
                        </div>
                    </td>
                    <td>{item?.displayName || "-"}</td>
                    {
                        ["email", "whatsapp", "weChat", "webNotification", "appNotification"].map((type, childIndex) => {
                            return <td key={index}>
                                {item?.[type] ? <div>
                                    {item?.[type]?.toLowerCase() === "unavailable" ? <GenericStatusComponent status={'UNAVAILABLE'}/> :
                                        <>
                                        {/* <GenericToggleComponent
                                            checked={item?.[type]?.toUpperCase() == "ENABLE"}
                                            checkedComponent={<p>Enable</p>}
                                            uncheckedComponent={<p>Disable</p>}
                                            disabled={item?.active == 0}
                                            onChange={() => {
                                                handleChange("updateTableData", {
                                                    key: type,
                                                    index: index
                                                })
                                            }}
                                        /> */}
                                        <Radio.Group
                                            value = {item?.[type]?.toUpperCase() == "ENABLE"} 
                                            disabled={item?.active == 0}
                                            onChange={(val) => { 
                                                handleChange("updateTableData", {
                                                    key: type,
                                                    index: index
                                                })
                                            }}
                                            className='flex items-center'
                                        >
                                                <Radio.Button
                                                    style={{ 
                                                        fontFamily: 'poppins',
                                                        borderRadius: '3px 0 0 3px'
                                                    }}
                                                    value="ENABLE"
                                                    className={`!text-xs pt-[7px] border !border-l-borderSlateGrey before:!bg-transparent hover:!bg-[#3EB655] hover:!text-white ${item?.[type]?.toUpperCase() == "ENABLE" ? '!border !border-l-[#3EB655] border-[#3EB655] !bg-[#3EB655] !text-white font-semibold' : '!text-fontGrey font-normal border-borderSlateGrey'}`}
                                                >
                                                    <LanguageTranslator>Enable</LanguageTranslator>
                                                </Radio.Button>
                                                <Radio.Button
                                                    style={{ 
                                                        fontFamily: 'poppins',
                                                        borderRadius: '0 3px 3px 0'
                                                    }}
                                                    value="DISABLE" 
                                                    className={`!text-xs pt-[7px] border before:!bg-transparent hover:!bg-[#FD3757] hover:!text-white ${item?.[type]?.toUpperCase() == "DISABLE" ? '!border !border-[#FD3757] !bg-[#FD3757] !text-white font-semibold' : '!text-fontGrey font-normal border-borderSlateGrey'}`}
                                                >
                                                        <LanguageTranslator>Disable</LanguageTranslator>
                                                </Radio.Button>
                                            </Radio.Group>
                                        </>
                                        }
                                </div>
                                    : "-"}
                            </td>
                        })
                    }
                </tr>
            })}
        </tbody>
    }

    return (
        <div className='notification-matrix h-[calc(100%-106px)] mt-[12px]'>
            {tableData?.length > 0 && renderFinalSubmitButtons()}

            {loading?.["main"] ?
                <div className='min-h-[250px] flex items-center justify-center'><GenericSpinnerLoader /></div>
                :
                errorData?.["main"] ?
                    <div className='w-full h-full flex flex-col items-center justify-center gap-2'>
                        <GenericCustomButton
                            type='retry'
                            onClick={() => { getData() }}
                        />
                        {/* <p className='mb-0 text-sm text-center text-fontGrey'>{error || "Something Went Wrong!"}</p> */}
                        <div className='gcrb-error-text'>
                            <LanguageTranslator>{errorData?.["main"] || "Failed to fetch the data!"}</LanguageTranslator>
                        </div>
                    </div> :
                    (updatedTableData?.length > 0 || tableData?.length > 0) ?
                        <div className='table-v2'>
                            <table>
                                <thead>
                                    <tr>
                                        <th><LanguageTranslator>Status</LanguageTranslator></th>
                                        <th><LanguageTranslator>Events</LanguageTranslator></th>
                                        <th><LanguageTranslator>Email</LanguageTranslator></th>
                                        <th><LanguageTranslator>Whatsapp</LanguageTranslator></th>
                                        <th><LanguageTranslator>WeChat</LanguageTranslator></th>
                                        <th><LanguageTranslator>Web Notifications</LanguageTranslator></th>
                                        <th><LanguageTranslator>App Notifications</LanguageTranslator></th>
                                    </tr>
                                </thead>
                                {/* <tbody> */}
                                {renderTableBody()}
                                {/* </tbody> */}
                            </table>
                        </div> : <NoDataFound />
            }
        </div>
    )
}

export default NotificationMatrix
